import { c as _c } from "react/compiler-runtime";
import CommonTablePagination from "@/components/utils/table/paginator/CommonTablePagination";
import { RatingWithProfileInfoAndLevel } from "@/entities/IProfile";
import { SortDirection } from "@/entities/ISort";
import { ProfileRatersParamsOrderBy, ProfileRatersTableType } from "@/enums";
import ProfileRatersTableBody from "./ProfileRatersTableBody";
import ProfileRatersTableHeader from "./ProfileRatersTableHeader";
export default function ProfileRatersTable(t0) {
  const $ = _c(11);
  const {
    ratings,
    type,
    order,
    orderBy,
    loading,
    totalPages,
    currentPage,
    setCurrentPage,
    onSortTypeClick,
    noRatingsMessage
  } = t0;
  let t1;
  if ($[0] !== currentPage || $[1] !== loading || $[2] !== noRatingsMessage || $[3] !== onSortTypeClick || $[4] !== order || $[5] !== orderBy || $[6] !== ratings || $[7] !== setCurrentPage || $[8] !== totalPages || $[9] !== type) {
    t1 = <>{ratings.length ? <div className="tw-flow-root"><div className="tw-inline-block tw-min-w-full tw-align-middle tw-pb-2"><table className="tw-min-w-full"><ProfileRatersTableHeader type={type} sortDirection={order} sortOrderBy={orderBy} isLoading={loading} onSortTypeClick={onSortTypeClick} /><ProfileRatersTableBody ratings={ratings} type={type} /></table></div>{totalPages > 1 && <CommonTablePagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} haveNextPage={currentPage < totalPages} small={true} />}</div> : <div className="tw-py-4"><span className="tw-px-4 sm:tw-px-6 tw-text-sm sm:tw-text-md tw-italic tw-text-iron-500">{noRatingsMessage}</span></div>}</>;
    $[0] = currentPage;
    $[1] = loading;
    $[2] = noRatingsMessage;
    $[3] = onSortTypeClick;
    $[4] = order;
    $[5] = orderBy;
    $[6] = ratings;
    $[7] = setCurrentPage;
    $[8] = totalPages;
    $[9] = type;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}